import React from 'react'

const ANP = () => {

    return (
        <div>
            <h2>Architecting New Possibilities</h2>
            <h3>Success Stories</h3>
            <h3>More from our clients</h3>
            <h3>The next big deal</h3>
            <h3>In The news</h3>
        </div>
    )
}

export default ANP